export default __webpack_public_path__ + "static/media/rar.6c1e5bf4.svg";